export default function getResource(label, vars = []) {
    const resources = {
        color: 'Color',
        size: 'Size',
        edit: 'Edit',
        type: 'Type',
        scent: 'Scent',
        sizeConcentration: 'Size + Concentration',
        save: 'Save',
        cancel: 'Cancel',
        gotIt: 'Got It',
        noVariants: 'This item has no options available to edit.',
        genericErrorMessage: 'Something went wrong, please try again.',
        changesNotSaved: 'Changes Not Saved',
        duplicateItem: 'Duplicate Item'
    };

    return resources[label];
}
